export interface AnalogyData {
  text1: string;
  text2: string;
}

export interface OcdFactData {
  text1: string;
  text2: string;
  text3: string;
}

export interface UserData {
  // Photo data
  selectedPhoto: File | null;
  photoDataUrl?: string;

  // OCD timeline
  ocdYear: number;

  // Time calculation
  totalLostDays: number;

  // User selections
  selectedAnalogy: AnalogyData | null;
  selectedOcdFact: OcdFactData | null;
  userMessage: string;

  // Processing state
  isComplete: boolean;
}

export interface UserDataContextType {
  userData: UserData;
  updateUserData: (updates: Partial<UserData>) => void;
  resetUserData: () => void;
}

export const defaultUserData: UserData = {
  selectedPhoto: null,
  photoDataUrl: undefined,
  ocdYear: new Date().getFullYear(),
  totalLostDays: 0,
  selectedAnalogy: null,
  selectedOcdFact: null,
  userMessage: '',
  isComplete: false,
};
